import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled, { keyframes } from "styled-components";

type Props = {
  target: HTMLElement | null;
  items: string[];
};

const HoverTooltip = ({ target, items }: Props) => {
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);

  useEffect(() => {
    if (!target) return;

    const rect = target.getBoundingClientRect();
    setPos({
      x: rect.left + rect.width / 2,
      y: rect.top,
    });
  }, [target]);

  if (!pos || items.length === 0) return null;

  return createPortal(
    <TooltipWrapper style={{ left: pos.x, top: pos.y }}>
      <TooltipCard>
        <TooltipHeader>Items ({items.length})</TooltipHeader>

        <TooltipList>
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </TooltipList>
      </TooltipCard>
    </TooltipWrapper>,
    document.body
  );
};

export default HoverTooltip;
const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -92%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%);
  }
`;

const TooltipWrapper = styled.div`
  position: fixed;
  z-index: 99999;
  pointer-events: none;
`;

const TooltipCard = styled.div`
  transform: translate(-50%, -100%);
  animation: ${fadeUp} 0.18s ease-out;

  min-width: 220px;
  max-width: 420px;

  background: #ffffff;
  color: #111827;

  border-radius: 12px;
  border: 1px solid #e5e7eb;

  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08),
    0 3px 6px rgba(15, 23, 42, 0.05);

  overflow: hidden;
`;

const TooltipHeader = styled.div`
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
`;

const TooltipList = styled.ul`
  margin: 0;
  padding: 8px 12px;

  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;

  li {
    font-size: 12px;
    line-height: 1.45;
    padding: 4px 6px;
    border-radius: 6px;

    background: #f8fafc;
    color: #111827;

    /* subtle hover 느낌 (실제 hover는 아님) */
    box-shadow: inset 0 0 0 1px #eef2f7;
  }
`;
